import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["eventType", "eventData"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _get from 'lodash/get';
import GoogleAnalytics from '../../../services/analytics';
import { FISHERMAN_BOT_EVENT } from '../../../services/analytics/google/google-analytics.constants';
export function getEventType(event) {
  var standardEventType = _get(event, 'type');
  var customEventType = _get(event, 'payload.eventType');
  return customEventType || standardEventType;
}
export function processGoogleAnalyticsEvent(event) {
  var _get2 = _get(event, 'payload', {}),
    eventType = _get2.eventType,
    _get2$eventData = _get2.eventData,
    eventData = _get2$eventData === void 0 ? {} : _get2$eventData,
    extraEventData = _objectWithoutProperties(_get2, _excluded);
  var category = eventData.category,
    action = eventData.action,
    _eventData$label = eventData.label,
    label = _eventData$label === void 0 ? '' : _eventData$label,
    value = eventData.value;
  GoogleAnalytics.event(category, action, _objectSpread({
    eventType: FISHERMAN_BOT_EVENT,
    label: label,
    value: value
  }, extraEventData));
}